import dayjs from 'dayjs'

export const parseJwt = (token: string) => {
  const base64Url = token.split('.')[1]
  if (!base64Url) {
    return {}
  }
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  return JSON.parse(window.atob(base64))
}

export const isTokenExpired = (token: string): boolean | null => {
  const tokenExpirationTime = getTokenExpirationTime(token)
  if (tokenExpirationTime !== null) {
    return tokenExpirationTime < 0
  }
  return null
}

export const getTokenExpirationTime = (token: string) => {
  const tokenObject = parseJwt(token)
  if (tokenObject.hasOwnProperty('exp')) {
    const now = dayjs().utc().unix() * 1000
    return tokenObject.exp * 1000 - now
  }
  return null
}
